import React, { useEffect, useState } from 'react';
import '../css/AddJob.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import StarRating from './StarRating';
import StatusBar from './StatusBar';
import { GrFormClose } from 'react-icons/gr';
import { CirclePicker } from 'react-color';
import { BsCalendar2Check } from 'react-icons/bs';
import { convertDateToYYMMDD, convertYYYMMDDtoDate, convertToReadable } from '../times';
import '../css/MyCalendar.css';
import { Misc } from './Misc';
import { LogoInput } from './LogoInput';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const AddJob = ({ columnMap, currentUser, isOpen, setIsOpen, setColumnMap }) => {
    const [jobTitle, setJobTitle] = useState('');
    const [appliedOn, setAppliedOn] = useState(null);
    const [followUp, setFollowUp] = useState(null);
    const [showAppliedOn, setShowAppliedOn] = useState(false);
    const [showFollowUp, setShowFollowUp] = useState(false);
    const [status, setStatus] = useState('wishlist');
    const [color, setColor] = useState({});
    const [excitement, setExcitement] = useState(0)
    const [logoUrl, setLogoUrl] = useState('')
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        // const theStatus = e.target.status.value;
        const reqBody = {
            job_title: e.target.jobTitle.value,
            company: e.target.company.value,
            location: e.target.jobLocation.value,
            applied_on: convertDateToYYMMDD(appliedOn),
            follow_up: convertDateToYYMMDD(followUp),
            excitement: excitement,
            status: status,
            color: color.hex,
            rank: columnMap[status].length,
            logo_url: logoUrl
        }
        console.log('reqBody', reqBody)
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/add/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Token ${currentUser.token}`
            },
            body: JSON.stringify(reqBody)
        });
        const data = await res.json();
        console.log(data)
        if (data.status_code === 'success') {
            setColumnMap(prev => {
                console.log('cM', columnMap);
                console.log('p', prev)
                prev[status].push(data.obj);
                return prev
            })
            setIsOpen(false);
        }
    };
    const onElemFocus = (e) => {
        e.target.parentElement.classList.add("focusWithText");
    };

    const onElemBlur = (e) => {
        if (e.target.value === "") {
            e.target.parentElement.classList.remove("focusWithText");
        }
    };
    useEffect(() => {
        const fieldArray = ['jobTitle', 'company', 'jobLocation']
        const myArr = []
        if (isOpen) {
            for (let field of fieldArray) {
                let fieldHTML = document.getElementById('add_' + field);
                myArr.push(fieldHTML)
                fieldHTML.addEventListener('focus', onElemFocus);
                fieldHTML.addEventListener('blur', onElemBlur);
            }
        }
        return () => {
            if (isOpen) {
                for (let field of myArr) {
                    // let fieldHTML = document.getElementById('add_' + field);
                    field.removeEventListener('focus', onElemFocus);
                    field.removeEventListener('blur', onElemBlur);
                }
            }
        }
    }, [isOpen]);
    if (!isOpen) return null
    return (
        <div className='modal glass'>
            <div className='job-box-background' style={{ backgroundColor: color.hex }} />
            <form id='add-job-form' className='add-job-grid gap-5' onSubmit={(e) => handleSubmit(e)}>
                <div className='modal-btn-container'>
                    <GrFormClose className='modal-btn' onClick={() => setIsOpen(false)} />
                    <button type='submit' style={{color: !color.hex||color.hex==='#ffeb3b'||color.hex===''? '#212121' : 'white'}}>ADD</button>
                    <div></div>
                </div>
                <div className='logo justify-self-center'>
                    <LogoInput logoUrl={logoUrl} setLogoUrl={setLogoUrl}/>
                </div>
                <div className="jobTitle">
                    <div className="inputGroup inputGroup1">
                        <input type="text" id="add_jobTitle" name='jobTitle' value={jobTitle} onChange={(e) => { setJobTitle(e.value) }} maxLength="256" autoComplete="off" required />
                        <p className="helper helper1">Add a role or position</p>
                    </div>
                </div>
                <div className='nameAndLocation'>
                    <div className="inputGroup inputGroup2">
                        <input type="text" id="add_company" name='company' className="company" maxLength="256" autoComplete="off" required />
                        <p className="helper helper1">Company Name</p>
                    </div>
                    <div className="inputGroup inputGroup2">
                        <input type="text" id="add_jobLocation" name='jobLocation' className="jobLocation" maxLength="256" autoComplete="off" />
                        <p className="helper helper1">Add a location</p>
                    </div>
                </div>
                <div className='appliedOn' >
                    <div className='mycalendar-container no-select'>
                        <div className='' >
                            <h5 className='flex cursor font-semibold items-center' onClick={() => setShowAppliedOn(prev => !prev)}>
                                Applied On &nbsp; <BsCalendar2Check />
                            </h5>
                            <div className='d-flex cursor'>
                                <h5 className='grow1' onClick={() => setShowAppliedOn(prev => !prev)}>{!!appliedOn ? <>Date: {convertToReadable(appliedOn)} </> : <>Add a date </>} </h5>
                                {!!appliedOn ? <GrFormClose className='modal-btn' onClick={() => setAppliedOn(null)} /> : null}
                            </div>
                        </div>
                        {showAppliedOn ? <Calendar className='mycalendar' onChange={(e) => { setAppliedOn(e) }} value={appliedOn} /> : null}
                    </div>
                </div>
                <div className='followUp'>
                    <div className='mycalendar-container no-select'>
                        <div className=''>
                            <h5 className='flex cursor font-semibold items-center' onClick={() => setShowFollowUp(prev => !prev)}>
                                Followed Up On &nbsp; <BsCalendar2Check />
                            </h5>
                            <div className='d-flex cursor'>
                                <h5 className='grow1' onClick={() => setShowFollowUp(prev => !prev)}>{!!followUp ? <>Date: {convertToReadable(followUp)} </> : <>Add a date </>} </h5>
                                {!!followUp ? <GrFormClose className='modal-btn' onClick={() => setFollowUp(null)} /> : null}
                            </div>
                        </div>
                        {showFollowUp ? <Calendar className='mycalendar' onChange={(e) => { setFollowUp(e) }} value={followUp} /> : null}
                    </div>
                </div>
                <div className='excitement'>
                    <StarRating rating={excitement} setRating={setExcitement} />
                    <CirclePicker onChange={(c) => setColor(c)} />
                </div>
                <div className="statusBar">
                    <StatusBar status={status} setStatus={setStatus} />
                </div>
                {/* <div className='misc'>
                    <div className="jobDescription">
                    <textarea className='keywords__textarea' rows={16} defaultValue={description} onChange={(e)=>{setTempDescription(e.target.value)}}>
                    </textarea>
                    </div>
                </div> */}
            </form>
        </div>
    )
};
export default AddJob;